import React, { useEffect, useState } from 'react'
import { reportsPageTabs, reportsPageTabIds } from '../GSConstants'
import { Box, Tab, Tabs } from '@mui/material'
import { Item } from '../../../common/snippets'
import { useSearchParams } from 'react-router-dom'
import GstInvoiceCofigPage from './GSTInvoiceCongiguration/GstInvoiceCofigPage'
import MonthlyTargetTable from './MonthlyTarget/MonthlyTargetTable'
import { findObjctByValueFromArrayOfObject } from '../../../common/helper'
import { useTranslation } from '../../../../i18n/I18nProvider'

export const reportsPageTabWithId = reportsPageTabs
const GSReportsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [selectedTab, setSelectedTab] = useState(Number(searchParams.get('id')) || 520)
  const [allTabs, setAllTabs] = useState([])
  const [activeTabs, setActiveTabs] = useState(reportsPageTabWithId)
  const { translations } = useTranslation()
  const gs = translations?.generalSettings || {}
  const tr = (key, fallback) => gs?.[key] || fallback

  useEffect(() => {
    const allGSPages = sessionStorage.getItem('token1');
    const allGSPagesActive = JSON.parse(allGSPages);
    if (allGSPagesActive?.length > 0) {
      setAllTabs(allGSPagesActive)
      const activeTabs = reportsPageTabWithId.filter((item) => findObjctByValueFromArrayOfObject(allGSPagesActive, item.JobID, 'JobID', "IsActive") === 1)
      setActiveTabs(activeTabs)
      setSelectedTab(activeTabs[0]?.JobID)
    } else {
      setAllTabs([])
    }
  }, []);
  const params = {}
  for (let entry of searchParams.entries()) {
    params[entry[0]] = entry[1]
  }
  const goToTabs = (lrTab) => {
    params.id = lrTab
    setSearchParams(params)
    setSelectedTab(lrTab)
  }
  const getReportsPageContent = (typeId, label) => {
    switch (typeId) {
      case 520:
        return <GstInvoiceCofigPage />
        break
      case 425:
        return <MonthlyTargetTable />
        break
      default:
        return label
    }
  }
  return (
    <>
      <Box className='autoTransPageTabContainer'>
        <Item sx={{ paddingTop: 0 }}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <Tabs value={selectedTab} onChange={(e, newValue) => goToTabs(newValue)} aria-label="bsic tabs example">
              {activeTabs.map((reqType, index) => (
                <Tab
                  key={`sender_${reqType.JobID}`}
                  value={reqType.JobID}
                  label={tr(reqType.translationKey, reqType.name)}
                  {...reportsPageTabIds(reqType.JobID)}
                  sx={{
                    fontSize: '1rem', height: '40px', minHeight: '40px', fontSize: '12px', fontWeight: '600',
                  }}
                />
              ))}
            </Tabs>
          </Box>
          {activeTabs.map((reqType, index) => (
            <div
              role="tabpanel"
              hidden={selectedTab !== reqType.JobID}
              id={`bookingPage-tabpanel-${index}`}
              aria-labelledby={`bookingPage-tab-${index}`}
              key={`senderSe_${index}`}
            >
              {selectedTab === reqType.JobID && <Box sx={{ p: 3 }}>{getReportsPageContent(reqType.JobID, tr(reqType.translationKey, reqType.name))}</Box>}
            </div>
          ))}
        </Item>
      </Box>
    </>
  )
}

export default GSReportsPage
